import * as React from 'react'
import MuiSwitch, { SwitchProps as MuiSwitchProps } from '@mui/material/Switch'
import FormControlLabel, {
  FormControlLabelProps as MuiLabelProps,
} from '@mui/material/FormControlLabel'
import { FieldProps } from 'formik'

interface Props
  extends FieldProps,
    Omit<MuiSwitchProps, 'name' | 'value' | 'form'> {
  label: string
  labelProps: Omit<MuiLabelProps, 'label' | 'control'>
}

export const MuiSwitchFormik: React.FC<Props> = ({
  form: { isSubmitting }, //, errors, touched },
  disabled = isSubmitting,
  field: { onBlur: fieldOnBlur, ...field },
  onBlur = fieldOnBlur,
  label,
  labelProps,
  ...props
}) => {
  const switchProps = {
    checked: field.value,
    ...field,
    ...props,
    disabled,
    onBlur:
      onBlur ??
      function (
        event: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>,
      ) {
        fieldOnBlur(event ?? field.name)
      },
  }
  return (
    <FormControlLabel
      {...labelProps}
      label={label}
      control={<MuiSwitch {...switchProps} />}
    />
  )
}
MuiSwitchFormik.displayName = 'MuiSwitchFormik'
